<template>
  <div class="ma-4">
    <div class="mb-3">
      <span class="main-title">ORDER DETAIL</span>
    </div>
    <orderDetail :order_id="$route.params.orderid"/>
  </div>
</template>

<script>

import orderDetail from "@/components/back-office/OrderOnline/OrderDetail";
import orderMessengerDetail from "@/components/back-office/OrderOnline/OrderMessDetail";
export default {
  components: {
    orderDetail,
    orderMessengerDetail
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Order report",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/order_report"
      },
      {
        text: "Order detail",
        disabled: true,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/order_report/order_detail"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
